import {MigrationInterface, QueryRunner, Table, TableIndex, TableColumn, TableForeignKey } from "typeorm";
import { News } from '@nsk-app/models';

export class AddNewsTable1635258789259 implements MigrationInterface {
  async up(queryRunner: QueryRunner): Promise<void> {
    const metaData = queryRunner.connection.getMetadata(News);
    let table = Table.create(metaData,queryRunner.connection.driver);
    await queryRunner.createTable(table,true);
  }

  async down(queryRunner: QueryRunner): Promise<void> {
    const metaData = queryRunner.connection.getMetadata(News);
    await queryRunner.dropTable(metaData.tableName,true);
  }
}
